import {
  RestrictionType,
  TenantDefaultUsersAuthenticationDto,
  UserDefaultAuthenticationDto
} from "@libs/api/gateways/plt/plt-gateway.dtos";

export interface UserAuthFormValues {
  sessionMaxDuration?: string;
  quickPinRequired: UserAuthOptions;
  mfaMethodCount?: number;
  mfaFirstOptions?: string[];
  mfaSecondOptions?: string[];
  restrictionType: RestrictionType;
}

// eslint-disable-next-line const-case/uppercase
export const MFA_METHODS_COUNT_MAP = {
  0: "None",
  1: "One",
  2: "Two"
};

export interface UserAuthFormProps {
  userAuth: UserDefaultAuthenticationDto | undefined;
  tenantAuth: TenantDefaultUsersAuthenticationDto | undefined;
  userId: string;
  tenantId: string;
}

export enum UserAuthOptions {
  on = 0,
  off = 1,
  default = 2
}

export const userAuthOptions = [
  { key: UserAuthOptions.default, text: "Default" },
  { key: UserAuthOptions.on, text: "On" },
  { key: UserAuthOptions.off, text: "Off" }
];

export const TENANT_AUTH_HINT = "Tenant default value:";
export const DEFAULT_MFA_COUNT_VALUE = -1;
